export default __webpack_public_path__ + "materialicons.3146fcbfa119727b2578.woff2";